import { Link } from "react-router-dom";

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            AllChinaBuy Spreadsheet vs. Traditional Agent Sites
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            See how our structured spreadsheet approach compares to conventional China buying platforms.
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="px-6 py-4 text-sm font-semibold text-foreground-950">Feature</th>
                  <th className="px-6 py-4 text-sm font-semibold text-primary-700 bg-primary-50/50">
                    AllChinaBuy Spreadsheet
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-foreground-700">
                    Traditional Agent Sites
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-200/70">
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">Supplier Transparency</td>
                  <td className="px-6 py-4 text-sm text-primary-700 bg-primary-50/30 font-medium">High</td>
                  <td className="px-6 py-4 text-sm text-foreground-600">Low</td>
                </tr>
                <tr className="border-b border-background-200/70">
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">Price Tracking</td>
                  <td className="px-6 py-4 text-sm text-primary-700 bg-primary-50/30 font-medium">Real-time Updates</td>
                  <td className="px-6 py-4 text-sm text-foreground-600">Static Listings</td>
                </tr>
                <tr className="border-b border-background-200/70">
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">Data Organization</td>
                  <td className="px-6 py-4 text-sm text-primary-700 bg-primary-50/30 font-medium">Structured Spreadsheet</td>
                  <td className="px-6 py-4 text-sm text-foreground-600">Unorganized Listings</td>
                </tr>
                <tr className="border-b border-background-200/70">
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">Risk Level</td>
                  <td className="px-6 py-4 text-sm text-primary-700 bg-primary-50/30 font-medium">Low</td>
                  <td className="px-6 py-4 text-sm text-foreground-600">Medium–High</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">Update Frequency</td>
                  <td className="px-6 py-4 text-sm text-primary-700 bg-primary-50/30 font-medium">Weekly</td>
                  <td className="px-6 py-4 text-sm text-foreground-600">Irregular</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            Learn more about our methodology
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}